export default "__VITE_ASSET__DIL_Cpcb__"